export enum PayFrequencyTypes {
  annual = 1,
  semiAnnual = 2,
  quarterly = 3,
  monthly = 4,
}
